"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var go = require("gojs/release/go");
var WallBuildingTool = (function (_super) {
    __extends(WallBuildingTool, _super);
    function WallBuildingTool() {
        var _this = _super.call(this) || this;
        _this._buildingWall = null;
        _this._isBuildingDivider = false;
        _this.name = 'WallBuilding';
        _this._startPoint = null;
        _this._endPoint = null;
        _this._wallReshapingTool = null;
        _this._isBuildingDivider = false;
        return _this;
    }
    Object.defineProperty(WallBuildingTool.prototype, "startPoint", {
        get: function () { return this._startPoint; },
        set: function (value) { this._startPoint = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallBuildingTool.prototype, "endPoint", {
        get: function () { return this._endPoint; },
        set: function (value) { this._endPoint = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallBuildingTool.prototype, "wallReshapingTool", {
        get: function () { return this._wallReshapingTool; },
        set: function (value) { this._wallReshapingTool = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallBuildingTool.prototype, "buildingWall", {
        get: function () { return this._buildingWall; },
        set: function (value) { this._buildingWall = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallBuildingTool.prototype, "isBuildingDivider", {
        get: function () { return this._isBuildingDivider; },
        set: function (value) { this._isBuildingDivider = value; },
        enumerable: true,
        configurable: true
    });
    WallBuildingTool.prototype.doActivate = function () {
        this.endPoint = null;
        this.startTransaction(this.name);
        this.diagram.isMouseCaptured = true;
        var tool = this;
        var fp = tool.diagram;
        var clickPt = tool.diagram.lastInput.documentPoint;
        var isSnapped = false;
        var walls = fp.findNodesByExample({ category: 'WallGroup' });
        walls.iterator.each(function (w) {
            if (fp.isPointInWall(w, clickPt)) {
                if (tool.buildingWall === null) {
                    var snapPt = clickPt.projectOntoLineSegmentPoint(w.data.startpoint, w.data.endpoint);
                    clickPt = snapPt;
                    isSnapped = true;
                }
            }
        });
        walls.iterator.each(function (w) {
            var sp = w.data.startpoint;
            var ep = w.data.endpoint;
            var distSp = Math.sqrt(sp.distanceSquaredPoint(clickPt));
            if (distSp < 15) {
                clickPt = sp;
                isSnapped = true;
            }
            var distEp = Math.sqrt(ep.distanceSquaredPoint(clickPt));
            if (distEp < 15) {
                clickPt = ep;
                isSnapped = true;
            }
        });
        if (true) {
            var gs = fp.model.modelData.gridSize;
            if (!(tool.diagram.toolManager.draggingTool.isGridSnapEnabled) || isSnapped)
                gs = .0001;
            var newx = gs * Math.round(clickPt.x / gs);
            var newy = gs * Math.round(clickPt.y / gs);
            clickPt = new go.Point(newx, newy);
        }
        this.startPoint = clickPt;
        this.wallReshapingTool = fp.toolManager.mouseDownTools.elt(3);
        this.isActive = true;
    };
    WallBuildingTool.prototype.doMouseDown = function () {
        var diagram = this.diagram;
        var tool = this;
        tool.diagram.currentCursor = 'crosshair';
        var data = {
            key: 'wall', category: 'WallGroup', caption: tool.isBuildingDivider ? 'Divider' : 'Wall', type: tool.isBuildingDivider ? 'Divider' : 'Wall',
            startpoint: tool.startPoint, endpoint: tool.startPoint, smpt1: tool.startPoint, smpt2: tool.startPoint, empt1: tool.startPoint, empt2: tool.startPoint,
            thickness: tool._isBuildingDivider ? 5 : parseFloat(diagram.model.modelData.wallThickness), color: tool.isBuildingDivider ? 'black' : 'lightgray', isGroup: true, notes: '',
            isDivider: tool.isBuildingDivider
        };
        this.diagram.model.addNodeData(data);
        var wall = diagram.findPartForKey(data.key);
        this.buildingWall = wall;
        var fp = diagram;
        fp.updateWall(wall);
        var part = diagram.findPartForData(data);
        if (part === null)
            return;
        tool.transactionResult = tool.name;
        diagram.raiseDiagramEvent('PartCreated', part);
        if (tool.wallReshapingTool === null)
            return;
        tool.wallReshapingTool.isEnabled = true;
        diagram.select(part);
        tool.wallReshapingTool.isBuilding = true;
        tool.wallReshapingTool.adornedShape = part.findObject('SHAPE');
        tool.wallReshapingTool.doActivate();
    };
    WallBuildingTool.prototype.doKeyDown = function () {
        var fp = this.diagram;
        var e = fp.lastInput;
        if (e.key === 'Esc') {
            var wall = fp.selection.first();
            fp.remove(wall);
            fp.pointNodes.iterator.each(function (node) { fp.remove(node); });
            fp.dimensionLinks.iterator.each(function (link) { fp.remove(link); });
            fp.pointNodes.clear();
            fp.dimensionLinks.clear();
            this.doDeactivate();
        }
        go.Tool.prototype.doKeyDown.call(this);
    };
    WallBuildingTool.prototype.doMouseMove = function () {
        if (this.wallReshapingTool === null)
            return;
        this.diagram.currentCursor = 'crosshair';
        this.wallReshapingTool.doMouseMove();
    };
    WallBuildingTool.prototype.doDeactivate = function () {
        var diagram = this.diagram;
        this.buildingWall = null;
        this.diagram.currentCursor = '';
        this.diagram.isMouseCaptured = false;
        if (this.wallReshapingTool !== null) {
            this.wallReshapingTool.isEnabled = false;
            this.wallReshapingTool.adornedShape = null;
            this.wallReshapingTool.doMouseUp();
            this.wallReshapingTool.doDeactivate();
            this.wallReshapingTool.isBuilding = false;
        }
        var fp = diagram;
        fp.updateWallDimensions();
        this.stopTransaction();
        this.isActive = false;
    };
    return WallBuildingTool;
}(go.Tool));
exports.WallBuildingTool = WallBuildingTool;
